module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n    404: Страница не найдена"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/"
    }
  }, [_c('Button', {
    staticClass: "button-primary",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("Перейти на главную")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5888760a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPages/404PageNotFound.vue
// module id = 360
// module chunks = 0